/* Pelvyr — pagina prodotto (migrata da Lovable), versione a sezioni modificabili.
   Ogni sezione è un host con Declarative Shadow DOM (.pelvyr-host). Questo script collega le interazioni
   di tutte le sezioni presenti nella pagina. Aggiunta al carrello: cart-drawer del tema Elixir. */
(function () {
  'use strict';
  /* UI strings by storefront language (falls back to Italian) */
  var PV_LANG = ((document.documentElement.getAttribute('lang') || 'it').slice(0, 2)).toLowerCase();
  var PV_T = {
    it: { busy: 'AGGIUNTA IN CORSO…', addErr: 'Non siamo riusciti ad aggiungere il prodotto al carrello. Riprova.', netErr: 'Impossibile contattare il negozio. Riprova.' },
    en: { busy: 'ADDING…', addErr: 'We couldn’t add this item to your cart. Please try again.', netErr: 'We couldn’t reach the store. Please try again.' },
    de: { busy: 'WIRD HINZUGEFÜGT…', addErr: 'Das Produkt konnte nicht in den Warenkorb gelegt werden. Bitte versuchen Sie es erneut.', netErr: 'Der Shop ist gerade nicht erreichbar. Bitte versuchen Sie es erneut.' }
  }[PV_LANG] || null;
  if (!PV_T) PV_T = { busy: 'AGGIUNTA IN CORSO…', addErr: 'Non siamo riusciti ad aggiungere il prodotto al carrello. Riprova.', netErr: 'Impossibile contattare il negozio. Riprova.' };
  if (window.__pelvyrInit) { window.__pelvyrInit(); return; }

  // Polyfill per i (rari) browser senza Declarative Shadow DOM.
  function attachShadowRoots(scope) {
    scope.querySelectorAll('template[shadowrootmode]').forEach(function (t) {
      var host = t.parentNode;
      if (!host || host.shadowRoot) { t.remove(); return; }
      try {
        var sr = host.attachShadow({ mode: t.getAttribute('shadowrootmode') || 'open' });
        sr.appendChild(t.content);
        t.remove();
      } catch (e) { /* già collegato */ }
    });
  }

  function findBuybox() {
    var hosts = document.querySelectorAll('.pelvyr-host');
    for (var i = 0; i < hosts.length; i++) {
      var b = hosts[i].shadowRoot && hosts[i].shadowRoot.querySelector('#acquista');
      if (b) return b;
    }
    return null;
  }

  function init(host) {
    if (!host || host.dataset.ready === '1') return;
    if (!host.shadowRoot) attachShadowRoots(host.parentNode || document);
    var root = host.shadowRoot;
    if (!root) return;
    host.dataset.ready = '1';

    var page = root.querySelector('.uc-page');
    var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

    /* ---------- Galleria ---------- */
    var stageImgs = $$('[data-stage] img');
    var thumbs = $$('[data-thumb]');
    var active = 0;
    function showImage(i) {
      var n = stageImgs.length;
      if (!n) return;
      active = (i + n) % n;
      stageImgs.forEach(function (im, k) {
        im.hidden = k !== active;
        if (k === active) im.removeAttribute('loading');
      });
      thumbs.forEach(function (b, k) {
        b.classList.toggle('selected', k === active);
        b.setAttribute('aria-pressed', k === active ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { showImage(Number(b.dataset.thumb)); }); });
    $$('[data-gal]').forEach(function (b) { b.addEventListener('click', function () { showImage(active + Number(b.dataset.gal)); }); });
    var stage = $('[data-stage]');
    if (stage) {
      var touchX = null;
      stage.addEventListener('touchstart', function (e) { touchX = e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var start = touchX; touchX = null;
        var end = e.changedTouches[0] ? e.changedTouches[0].clientX : null;
        if (start == null || end == null) return;
        var dx = end - start;
        if (Math.abs(dx) < 40) return;
        showImage(active + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    /* ---------- Offerte / regali / carrello ---------- */
    var offers = $$('.uc-offer');
    var addBtn = $('[data-add]');
    var errEl = $('[data-error]');
    var busy = false;
    var giftIds = (host.dataset.giftIds || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    function selectedOffer() { return offers.filter(function (o) { return o.getAttribute('aria-checked') === 'true'; })[0] || offers[0]; }
    function applySelection(offer) {
      if (!offer) return;
      offers.forEach(function (o) {
        var on = o === offer;
        o.classList.toggle('selected', on);
        o.setAttribute('aria-checked', on ? 'true' : 'false');
        var radio = $('.uc-offer-radio', o);
        if (radio) radio.classList.toggle('on', on);
      });
      var idx = Number(offer.dataset.index) || 0;
      page.setAttribute('data-tier', String(Math.min(idx, 2)));
      if (addBtn) addBtn.disabled = busy || offer.disabled;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    }
    offers.forEach(function (o) { o.addEventListener('click', function () { if (!o.disabled) applySelection(o); }); });

    function showError(msg) { if (errEl) { errEl.textContent = msg; errEl.hidden = false; } }
    function setBusy(v) {
      busy = v;
      if (!addBtn) return;
      var label = addBtn.querySelector('span');
      addBtn.disabled = v || selectedOffer().disabled;
      if (label && label.firstChild) {
        if (!addBtn.dataset.label) addBtn.dataset.label = label.firstChild.textContent;
        label.firstChild.textContent = v ? ((host.dataset.busyLabel || PV_T.busy) + ' ') : addBtn.dataset.label;
      }
    }
    async function addToCart() {
      if (busy || !addBtn || addBtn.disabled) return;
      var offer = selectedOffer();
      var variantId = Number(offer.dataset.variantId);
      var tier = Number(offer.dataset.index) || 0;
      setBusy(true);
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      try {
        var items = [{ id: variantId, quantity: 1 }];
        if (tier > 0 && giftIds.length) {
          var inCart = [];
          try {
            var c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
            inCart = (c.items || []).map(function (i) { return String(i.variant_id); });
          } catch (e) { /* se /cart.js fallisce, aggiungo comunque i regali */ }
          giftIds.forEach(function (g) { if (inCart.indexOf(String(g)) === -1) items.push({ id: Number(g), quantity: 1 }); });
        }
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
        var res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body)
        });
        var data = await res.json();
        if (!res.ok || data.status) {
          showError(data.description || data.message || PV_T.addErr);
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
          data.id = variantId;
          drawer.renderContents(data);
          try {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pelvyr-page', productVariantId: variantId, cartData: data });
            }
          } catch (e) { /* eventi opzionali */ }
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      } catch (err) {
        showError(PV_T.netErr);
      } finally {
        setBusy(false);
      }
    }
    if (addBtn) addBtn.addEventListener('click', addToCart);
    if (offers.length) applySelection(selectedOffer());

    /* ---------- Accordion, benefici, tab esperti, recensioni ---------- */
    $$('.uc-acc').forEach(function (acc, _, all) {
      var btn = $('button', acc);
      btn.addEventListener('click', function () {
        var open = !acc.classList.contains('open');
        all.forEach(function (a) {
          var o = a === acc && open;
          a.classList.toggle('open', o);
          $('button', a).setAttribute('aria-expanded', o ? 'true' : 'false');
          $('.uc-acc-body', a).hidden = !o;
        });
      });
    });
    $$('.uc-proofs-grid article').forEach(function (art, _, all) {
      var btn = $('button', art);
      btn.addEventListener('click', function () {
        var open = !art.classList.contains('open');
        all.forEach(function (a) {
          var o = a === art && open;
          a.classList.toggle('open', o);
          $('button', a).setAttribute('aria-expanded', o ? 'true' : 'false');
          $('p', a).hidden = !o;
        });
      });
    });
    var tabs = $$('[data-tab]'), panels = $$('[data-panel]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.dataset.tab;
        tabs.forEach(function (x) { var on = x === t; x.classList.toggle('selected', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.dataset.panel !== i; });
      });
    });
    var track = $('[data-reviews]');
    $$('[data-rev]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (track) track.scrollBy({ left: Number(b.dataset.rev) * track.clientWidth, behavior: 'smooth' });
      });
    });

    /* ---------- Ancora "acquista" (anche da altre sezioni) e barra fissa ---------- */
    $$('a[href="#acquista"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = findBuybox();
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var sticky = $('[data-sticky]');
    var buybox = $('#acquista');
    if (sticky && buybox) {
      var onScroll = function () { sticky.classList.toggle('visible', buybox.getBoundingClientRect().bottom < 0); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      onScroll();
    }
  }

  function initAll() {
    attachShadowRoots(document);
    document.querySelectorAll('.pelvyr-host').forEach(init);
  }
  window.__pelvyrInit = initAll;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  // Editor del tema: la sezione viene ridisegnata
  document.addEventListener('shopify:section:load', function (e) {
    var hosts = e.target ? e.target.querySelectorAll('.pelvyr-host') : [];
    hosts.forEach(function (h) { delete h.dataset.ready; });
    initAll();
  });
})();
